export default "__VITE_ASSET__OfQ3rqv7__"